import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import { WorksForm, TrainingsForm, EducationsForm } from './components';
import { getInitialValues, getValidationSchema } from './helpers/addEditForm';
import { maxSymbolQTY } from '../../../utils/constants';
import AddEditCVRecordWrapper from './components/AddEditCVRecordWrapper';

function AddEditCVRecord(props) {
  const {
    closeHandler,
    confirmHandler,
    deleteHandler,
    editeMode,
    initData,
    block,
    extra,
    withCurrentlyCheckBox,
    shouldImmediatelySave = false
  } = props;

  const [isConfirmUnAllowed, setIsConfirmUnAllowed] = useState(false);
  const { t } = useTranslation();

  let resultInitData = ['functions', 'industries', 'skills'].includes(block) ? initData : { ...initData };

  if (withCurrentlyCheckBox) {
    resultInitData = {
      ...resultInitData,
      withCurrentlyCheckBox,
      ...extra,
      originalValue: block === 'works' ? initData?.CurrentlyWorkThere : initData?.CurrentlyStudyHere
    };
  }

  const addEditForm = useFormik({
    initialValues: getInitialValues(editeMode, resultInitData, block, t),
    validationSchema: getValidationSchema(block, resultInitData, t),
    initialTouched:
      editeMode &&
      Object.keys(getInitialValues(editeMode, resultInitData, block, t)).reduce((acc, key) => {
        acc[key] = true;
        return acc;
      }, {}),
    onSubmit: (values) => confirmHandler(values)
  });

  const componentsForBlocks = {
    works: (
      <WorksForm
        withCurrentlyCheckBox={withCurrentlyCheckBox}
        addEditForm={addEditForm}
        deleteHandler={deleteHandler}
      />
    ),
    educations: (
      <EducationsForm
        withCurrentlyCheckBox={withCurrentlyCheckBox}
        addEditForm={addEditForm}
        deleteHandler={deleteHandler}
      />
    ),
    trainings: <TrainingsForm addEditForm={addEditForm} deleteHandler={deleteHandler} />
  };

  const changeDisableConfirmState = () => {
    if (
      (block === 'educations' &&
        (addEditForm.values.school?.length > maxSymbolQTY.SCHOOL ||
          addEditForm.values.degree?.length > maxSymbolQTY.DEGREE ||
          addEditForm.values.fieldofstudy?.length > maxSymbolQTY.FIELD_OF_STUDY)) ||
      (block === 'trainings' &&
        (addEditForm.values.type?.length > maxSymbolQTY.TYPE ||
          addEditForm.values.certId?.length > maxSymbolQTY.CERTIFICATE_ID))
    ) {
      setIsConfirmUnAllowed(true);
    } else {
      setIsConfirmUnAllowed(false);
    }
  };

  useEffect(() => {
    addEditForm.validateForm();
  }, []);

  useEffect(() => {
    changeDisableConfirmState();
  }, [
    addEditForm.values.school,
    addEditForm.values.degree,
    addEditForm.values.fieldofstudy,
    addEditForm.values.type,
    addEditForm.values.certId
  ]);

  return (
    <AddEditCVRecordWrapper
      closeHandler={closeHandler}
      confirmHandler={addEditForm.handleSubmit}
      disableConfirmBtn={isConfirmUnAllowed}
      immediatelySaveData={shouldImmediatelySave ? addEditForm.handleSubmit : () => {}}
      shouldImmediatelySave={shouldImmediatelySave}
      editMode={editeMode}
    >
      {componentsForBlocks[block]}
    </AddEditCVRecordWrapper>
  );
}

export default AddEditCVRecord;
